<template>
  <el-menu :default-active="initActive" background-color="#545c64" text-color="#fff" active-text-color="#ffd04b"
    :router="true" :collapse="isCollapse">
    <el-sub-menu index="1" v-if="
      useAuthority.GetAuthority('Menu_Order_BB_read') ||
      useAuthority.bHasRole('SuperAdmin')
    ">
      <template #title>
        <span>Order</span>
      </template>
      <el-menu-item index="report" :route="{ name: 'report' }">Order List</el-menu-item>
      <el-menu-item index="MyTask" v-if="useAuthority.GetAuthority('Menu_MyTaskList_read')"
        :route="{ name: 'MyTask' }">My
        Task List</el-menu-item>
    </el-sub-menu>
    <el-sub-menu index="1.1" v-if="
      useAuthority.GetAuthority('Menu_Order_BB_read') ||
      useAuthority.bHasRole('SuperAdmin') ||
      useAuthority.isSalesAdmin()
    ">
      <template #title>
        <span>Contract</span>
      </template>
      <el-menu-item index="reportContract" :route="{ name: 'reportContract' }">Contract List</el-menu-item>
      <el-menu-item index="ContractListByItem" :route="{ name: 'ContractListByItem' }">Contract List by
        Item</el-menu-item>
      <el-menu-item v-if="
        useAuthority.bHasRole('SuperAdmin') || useAuthority.isSalesAdmin()
      " index="getContractNumber" :route="{ name: 'getContractNumber' }">Get Contract Number</el-menu-item>
      <el-menu-item index="MediaSummary" :route="{ name: 'MediaSummary' }">Media Summary</el-menu-item>
    </el-sub-menu>
    <el-sub-menu index="3" v-if="
      useAuthority.GetAuthority('Menu_Finance_read') ||
      useAuthority.bHasRole('SuperAdmin')
    ">
      <template #title>
        <span>Finance</span>
      </template>
      <!-- :route="{ name: 'AAContractSummary' }" -->
      <el-menu-item index="AAContractSummary" @click="OpenIndex('AAContractSummary')">AA Contract Summary</el-menu-item>
      <el-menu-item index="AMContractSummary" @click="OpenIndex('AMContractSummary')">AM Contract Summary</el-menu-item>
      <el-menu-item index="GPContractSummary" @click="OpenIndex('GPContractSummary')">GP Contract Summary</el-menu-item>
      <el-menu-item index="KingdeeSync" @click="OpenIndex('KingdeeSync')">Kingdee Sync</el-menu-item>

    </el-sub-menu>
    <el-sub-menu index="4" v-if="useAuthority.bHasRole('SuperAdmin')">
      <template #title>
        <span>Administrator</span>
      </template>
      <el-menu-item index="ContractManage" :route="{ name: 'ContractManage' }">Contract Manage</el-menu-item>
      <!-- <el-menu-item index="tandcTemplate" :route="{ name: 'tandcTemplate', query: { type: 'list' } }">Contract T&C
        Template</el-menu-item>
      <el-menu-item index="testTandC" :route="{ name: 'testTandC' }">Test T&C</el-menu-item> -->
      <el-menu-item index="UserManage" :route="{ name: 'UserManage' }">UserManage</el-menu-item>
      <el-menu-item index="SystemManage" :route="{ name: 'SystemManage' }">SystemManage</el-menu-item>
      <el-menu-item index="ProcessManage" :route="{ name: 'ProcessManage' }">ProcessManage</el-menu-item>
    </el-sub-menu>
  </el-menu>
</template>

<script setup>
import { ref, onBeforeMount } from 'vue';
import { useAuthorityStore } from '@/store/authority';
import router from '@/router/index';
const isCollapse = ref(false);
//激活的菜单
const initActive = ref('report');
const useAuthority = useAuthorityStore();
import { routeParamsStore } from '@/store/routeParams';
var useParam = routeParamsStore();
//处理浏览器刷新页面激活菜单处理,根据浏览器路径激活对应的菜单
const menuList = ref([
  'report',
  'MyTask',
  'reportContract',
  'getContractNumber',
  'AAContractSummary',
  'AMContractSummary',
  'GPContractSummary',
  'KingdeeSync',
  'tandcTemplate',
  'testTandC',
  'UserManage',
  'SystemManage',
  'ContractListByItem',
]);
const OpenIndex = (urlpath) => {
  var pathname = window.location.pathname.replace(/\//g, '');
  if (pathname !== urlpath) {
    // location.href = '/' + urlpath;
    window.location.replace('/' + urlpath);
  }
};

onBeforeMount(async () => {
  //浏览器路径
  var pathname = window.location.pathname.replace(/\//g, '');
  //激活的菜单
  if (menuList.value.includes(pathname)) {
    initActive.value = pathname;
  } else {
    //不存在的就取设置的跳转激活
    if (useParam.home === 'myTask') {
      initActive.value = 'MyTask';
    }
  }
});
//import { reactive } from "vue";

// const Menus = reactive([
//   {
//     FolderCode: "Order",
//     FolderName: "Order",
//     NextMenus: [
//       {
//         PostName: "Order",
//       },
//     ],
//   },
// ]);

// const Open = (routeName) => {
//   if (routeName === "task") {
//     location.href = "/tasklist";
//   }
// };
</script>

<style scoped>
.el-menu {
  height: 100%;
}
</style>
